(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oi-load-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oi-load-more')) {
    class OiLoadMore extends HTMLElement {
      /** @type {AbortController | null} */
      controller = null;

      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.controller?.abort();
      }

      handleClick = async (event) => {
        const link = this.querySelector('[data-oi-load-more-link]');
        if (!(link instanceof HTMLAnchorElement)) return;
        if (!(event.target instanceof Node) || !link.contains(event.target)) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;

        event.preventDefault();
        if (this.controller) return;

        const sectionId = this.dataset.sectionId;
        const grid = document.querySelector(`#shopify-section-${sectionId} [ref="grid"]`);
        const status = this.querySelector('[data-oi-load-more-status]');
        if (!sectionId || !grid) {
          window.location.assign(link.href);
          return;
        }

        const url = new URL(link.href, window.location.href);
        url.searchParams.set('section_id', sectionId);

        this.controller = new AbortController();
        this.setAttribute('aria-busy', 'true');
        link.setAttribute('aria-disabled', 'true');
        if (status) status.textContent = status.getAttribute('data-loading') || '';

        try {
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const html = await response.text();
          const page = new DOMParser().parseFromString(html, 'text/html');
          const items = page.querySelectorAll('[ref="grid"] > [ref="cards[]"]');
          const firstNew = items[0];

          grid.append(...items);

          const nextLink = page.querySelector(`oi-load-more[data-section-id="${sectionId}"] [data-oi-load-more-link]`);
          if (nextLink instanceof HTMLAnchorElement) {
            link.href = nextLink.getAttribute('href') || link.href;
            link.removeAttribute('aria-disabled');
            if (status) status.textContent = status.getAttribute('data-loaded') || '';
          } else {
            const focusTarget = firstNew?.querySelector('a[href]');
            if (focusTarget instanceof HTMLElement) focusTarget.focus({ preventScroll: true });
            this.remove();
          }
        } catch (error) {
          if (error instanceof DOMException && error.name === 'AbortError') return;
          window.location.assign(link.href);
        } finally {
          this.controller = null;
          this.removeAttribute('aria-busy');
        }
      };
    }

    customElements.define('oi-load-more', OiLoadMore);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oi-qty-option"] && !Shopify.designMode) return;
  try {
    // Fecha a lista de pacotes ao escolher uma opção, ao clicar fora ou com Esc.
  document.addEventListener('change', (event) => {
    const list = event.target.closest('[data-oi-qty]');
    if (list) list.open = false;
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-oi-qty][open]').forEach((list) => {
      if (!list.contains(event.target)) list.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const list = event.target.closest('[data-oi-qty][open]');
    if (!list) return;
    list.open = false;
    list.querySelector('summary')?.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
